import { render } from "./CustomWechat.vue?vue&type=template&id=65b24423&scoped=true&ts=true"
import script from "./CustomWechat.vue?vue&type=script&lang=ts"
export * from "./CustomWechat.vue?vue&type=script&lang=ts"

import "./CustomWechat.vue?vue&type=style&index=0&id=65b24423&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b24423"]])

export default __exports__